import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTBodyRow as ClbTableTBodyRow_ } from '@celebration/design-system/dist/lib/table-tbody-row';
const events = {
    onClbSelectRow: ClbTableTBodyRow_.events
        .onClbSelectRow,
};
export const ClbTableTBodyRow = createComponent({
    tagName: ClbTableTBodyRow_.tagName,
    elementClass: ClbTableTBodyRow_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map